module.exports = __webpack_public_path__ + "img/icon-export-light-blue.0dfb9f09.svg";